import { render, staticRenderFns } from "./VkLoadableButton.vue?vue&type=template&id=6f8077f6&"
import script from "./VkLoadableButton.vue?vue&type=script&lang=js&"
export * from "./VkLoadableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports